var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sfcActionBar" }, [
    _c("div", { staticClass: "sfcActionScale" }, [
      _c(
        "div",
        { staticClass: "sfcActionScaleBtn", on: { click: _vm.scaleIn } },
        [
          _c(
            "svg",
            {
              attrs: {
                viewBox: "0 0 1024 1024",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M580.722174 437.990403 580.722174 78.171384 436.794158 78.171384 436.794158 437.990403 76.975139 437.990403 76.975139 581.918419 436.794158 581.918419 436.794158 941.737438 580.722174 941.737438 580.722174 581.918419 940.542216 581.918419 940.542216 437.990403Z",
                },
              }),
            ]
          ),
        ]
      ),
      _c("div", { staticClass: "sfcActionScaleNum" }, [
        _vm._v(_vm._s(_vm.scale.toFixed(0)) + "%"),
      ]),
      _c(
        "div",
        { staticClass: "sfcActionScaleBtn", on: { click: _vm.scaleOut } },
        [
          _c(
            "svg",
            {
              attrs: {
                viewBox: "0 0 1024 1024",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M587.229378 437.990403 580.722174 437.990403 76.975139 437.990403 76.975139 581.918419 580.722174 581.918419 587.229378 581.918419 940.542216 581.918419 940.542216 437.990403Z",
                },
              }),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }